import { EMOJIS, LiveGameReactionId, LiveGameCustomEventId } from "@ollie-sports/models";
import { getUniversalHelpers } from "../../helpers";

export async function liveGameCustomEvent__client__setEmojiReaction(p: {
  liveGameCustomEventId: LiveGameCustomEventId;
  reaction: EMOJIS;
  accountId: string;
  state: boolean;
}) {
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  await h.LiveGameCustomEvent.update({
    id: p.liveGameCustomEventId,
    doc: { reactions: { [p.accountId]: { [p.reaction]: p.state ? true : h._MagicDeleteValue } } }
  });
}

// i18n certified - complete
